// extracted by mini-css-extract-plugin
export default {"loginWrapper":"ForgotPassword_loginWrapper__e-nEq","loginBlock":"ForgotPassword_loginBlock__7shjN"};